export enum BannerType {
  Info = 'Info',
}
